import React from "react";
import Filters from "./Filters";
import ListTemplate, { listTemplateQueryKey } from "components/ListTemplate";
import { cardLayout } from "./cardLayout";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import { useQueryClient } from "@tanstack/react-query";
import { useLoaderData } from "react-router";
import TrainModal from "train/TrainModal";

const TrainListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.TrainListFrontModel>();

  const queryClient = useQueryClient();

  const onShowChange = () => {
    queryClient.invalidateQueries([listTemplateQueryKey]);
  }

  return <>
    <TrainModal />
    <ListTemplate
      title={RESX.Train.Trains}
      filterSet="train_List"
      defaultFilters={viewModel.defaultFilters}
      initialInstruction={viewModel.initialInstruction}
      fetchFunction={window.CoreApi.Train.Paginated}
      getId={item => item.segment.id}
      layout={cardLayout(onShowChange)}
      filters={<Filters />}
      functions={{
        mapFilterValuesToInstruction,
        mapResponseToFilterValues
      }}
    />
  </>;
};

export default TrainListApp;
